export default __webpack_public_path__ + "static/Blair-43f657302b2ad34577397f5d8b5c0b55.jpg";